"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowALeftIcon = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var Icon_1 = require("../../internal/Icon");
var ArrowALeftIcon16Light_1 = require("./ArrowALeftIcon16Light");
var ArrowALeftIcon16Regular_1 = require("./ArrowALeftIcon16Regular");
var ArrowALeftIcon16Solid_1 = require("./ArrowALeftIcon16Solid");
var ArrowALeftIcon20Light_1 = require("./ArrowALeftIcon20Light");
var ArrowALeftIcon20Regular_1 = require("./ArrowALeftIcon20Regular");
var ArrowALeftIcon20Solid_1 = require("./ArrowALeftIcon20Solid");
var ArrowALeftIcon24Regular_1 = require("./ArrowALeftIcon24Regular");
var ArrowALeftIcon24Solid_1 = require("./ArrowALeftIcon24Solid");
var ArrowALeftIcon32Regular_1 = require("./ArrowALeftIcon32Regular");
var ArrowALeftIcon64Regular_1 = require("./ArrowALeftIcon64Regular");
var sizes = {
    16: {
        light: ArrowALeftIcon16Light_1.ArrowALeftIcon16Light,
        regular: ArrowALeftIcon16Regular_1.ArrowALeftIcon16Regular,
        solid: ArrowALeftIcon16Solid_1.ArrowALeftIcon16Solid,
    },
    20: {
        light: ArrowALeftIcon20Light_1.ArrowALeftIcon20Light,
        regular: ArrowALeftIcon20Regular_1.ArrowALeftIcon20Regular,
        solid: ArrowALeftIcon20Solid_1.ArrowALeftIcon20Solid,
    },
    24: {
        regular: ArrowALeftIcon24Regular_1.ArrowALeftIcon24Regular,
        solid: ArrowALeftIcon24Solid_1.ArrowALeftIcon24Solid,
    },
    32: {
        regular: ArrowALeftIcon32Regular_1.ArrowALeftIcon32Regular,
    },
    64: {
        regular: ArrowALeftIcon64Regular_1.ArrowALeftIcon64Regular,
    },
};
exports.ArrowALeftIcon = forwardRef_1.forwardRef('ArrowALeftIcon', function (props, ref) {
    return react_1.default.createElement(Icon_1.Icon, tslib_1.__assign({ ref: ref }, props, { sizes: sizes }));
});
